import {Action} from '@ngrx/store';
import {AzureAdMandantOptions} from '../../../clients/api';
import {SmtpMandantOptions, TroubleTicketMandantOptions} from '../../../clients/kommunikation';

export const PAGE_STATE_RESET = '[MandantenverwaltungPage] Page State reset';

export const AZURE_AD_CONFIG_INPUT = '[MandantenverwaltungPage] AzureAd Config Eingabe';
export const SMTP_CONFIG_INPUT = '[MandantenverwaltungPage] Smtp Config Eingabe';
export const SMTP_TESTMAIL = '[MandantenverwaltungPage] Smtp Testmail senden';
export const TROUBLE_TICKET_CONFIG_INPUT = '[MandantenverwaltungPage] TroubleTicket Config Eingabe';
export const TECHNISCHE_ZUGRIFFE_SPEICHERN = '[MandantenverwaltungPage] Technische Zugriffe Speichern';


// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// Technische Zugriffe
export class AzureAdConfigInput implements Action {
    readonly type = AZURE_AD_CONFIG_INPUT;

    constructor(public payload: AzureAdMandantOptions) {}
}
export class SmtpConfigInput implements Action {
    readonly type = SMTP_CONFIG_INPUT;

    constructor(public payload: SmtpMandantOptions) {}
}
export class SmtpTestmail implements Action {
    readonly type = SMTP_TESTMAIL;
    constructor() {}
}
export class TroubleTicketConfigInput implements Action {
    readonly type = TROUBLE_TICKET_CONFIG_INPUT;

    constructor(public payload: TroubleTicketMandantOptions) {}
}
export class TechnischeZugriffeSpeichern implements Action {
    readonly type = TECHNISCHE_ZUGRIFFE_SPEICHERN;

    constructor() {}
}



export type Actions =
    | PageStateResetAction
    | AzureAdConfigInput
    | SmtpConfigInput
    | SmtpTestmail
    | TroubleTicketConfigInput
    | TechnischeZugriffeSpeichern
    ;
